import React from 'react';
import { useEffect, useState } from 'react';

const Hero = () => {
    return (
        <div className="bg-gray-900">
            <section className="mx-auto max-w-screen-xl px-4 pt-16 pb-32 items-center lg:flex md:px-8">
                <div className="space-y-4 flex-1 sm:text-center lg:text-left">
                    <h1 className="text-white font-bold text-4xl xl:text-5xl">
                        Plant your trees with the best
                        <span className="text-indigo-400"> tree planting</span> service
                    </h1>
                    <p className="text-gray-300 max-w-xl leading-relaxed sm:mx-auto lg:ml-0">
                        We provide the best tree planting service in the country. Our team of
                        professionals will help you plant your trees in the best possible way.
                    </p>
                    <div className="pt-10 items-center justify-center space-y-3 sm:space-x-6 sm:space-y-0 sm:flex lg:justify-start">
                        <a
                            href="javascript:void(0)"
                            className="px-7 py-3 w-full bg-white text-gray-800 text-center rounded-md shadow-md block sm:w-auto"
                        >
                            Learn more
                        </a>
                        <a
                            href="javascript:void(0)"
                            className="px-7 py-3 w-full bg-gray-700 text-gray-200 text-center rounded-md block sm:w-auto"
                        >
                            Plant now
                        </a>
                    </div>
                </div>
                <div className="flex-1 text-center mt-4 lg:mt-0 lg:ml-2">
                    <img
                        src="./images/home/hero-flat-design-tree-planting-illustration.png"
                        className="w-full mx-auto sm:w-10/12 lg:w-full"
                        alt="Hero image"
                    />
                </div>
            </section>
        </div>
    );
};

export default Hero;
